import * as React from "react";

import {cs} from "@Common/react/chain-services";

import {MyListingsLoadingModal} from "./my-listings-loading-modal";

export const MyListingsPrompt = ({next}) => cs(
    ["modal", ({}, next) => MyListingsLoadingModal({next})],
    ({modal}) => next(() => new Promise((resolve, reject) => {
        modal.show({resolve});
    })),
);
